<div class="onboarding-dialog">
    <div class="dialog-content" [innerHTML]="data.content"></div>
    <div class="dialog-actions">
        <div class="orientation-button-container">
            <app-button icon="arrow-right" (onClick)="redirect()">{{data.redirectButtonLabel}}</app-button>
          </div>
    </div>
</div>